import { TableHeaderCell } from 'components/common';

import { TableHeader, TableRow } from '@project44/manifest-ds';

export interface TableHeaderRowProps {
  disabledSort?: boolean;
  doSearch?: () => void;
  headers: Array<{
    id: string;
    label: string;
    width: string;
    options?: Array<{ label: string; value: string }>;
  }>;
  isLoading: boolean;
}

const styles = {
  row: {
    '&:hover .manifest-table-cell': {
      bgColor: '$background-primary',
    },
  },
};

function TableHeaderRow({
  disabledSort = false,
  doSearch,
  headers,
  isLoading,
}: TableHeaderRowProps) {
  return (
    <TableHeader css={{ height: '56px' }}>
      <TableRow css={styles.row}>
        {headers.map(({ id, label, options, width = '200px' }) => (
          <TableHeaderCell
            key={id}
            css={{ width }}
            disabled={disabledSort}
            doSearch={doSearch}
            isLoading={isLoading}
            options={options}
            title={label}
          />
        ))}
      </TableRow>
    </TableHeader>
  );
}

export default TableHeaderRow;
